/** H4: a tile/field counts as seen once at least half of it stays on screen for 2 s. Not configurable. */
export const SEEN_MIN_FRACTION = 0.5;
export const SEEN_DWELL_MS = 2000;

const REPORTED = -1;

export class DwellTracker {
    constructor({dwellMs = SEEN_DWELL_MS, minFraction = SEEN_MIN_FRACTION} = {}) {
        this.dwellMs = dwellMs;
        this.minFraction = minFraction;
        this._since = new Map();
    }

    /**
     * `fractions`: Map of candidate key → visible fraction for this tick. Candidates missing from the
     * map or below the threshold lose their timer. Returns the keys that just completed their dwell;
     * each is reported once until it leaves the view again.
     */
    update(fractions, now) {
        const done = [];
        const next = new Map();
        fractions.forEach((fraction, key) => {
            if (!(fraction >= this.minFraction)) return;
            const since = this._since.has(key) ? this._since.get(key) : now;
            if (since !== REPORTED && now - since >= this.dwellMs) {
                done.push(key);
                next.set(key, REPORTED);
            } else {
                next.set(key, since);
            }
        });
        this._since = next;
        return done;
    }

    reset() {
        this._since = new Map();
    }

    get size() {
        return this._since.size;
    }
}
